import { StyGridContainer } from 'routes/HumanResourcesModule/components/ui/StyGridContainer';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const CustomGridContainer = styled(StyGridContainer, {
    name: 'CustomGridContainer',
})({
    // remove default grid container columns border style
    '&&&  .ag-header-group-cell-with-group, .ag-header-cell': {
        borderLeft: 'none !important',
    },
    '&&& .ag-cell': {
        borderRight: 'none !important',
    },
    '&&& .ag-cell-wrapper': {
        height: '100%',
        width: '100%',
    },

    '&&& .ag-group-value': {
        height: '100%',
        width: '100%',
    },
    marginBottom: '1rem',
    height: '100%',
    width: '100%',
});

export const StyMappingHeader = styled(Box, {
    name: 'StyHRMappingsHeader',
})(() => ({
    display: 'flex',
    padding: '0em 1em',
    flexDirection: 'column',
    height: '7em',
}));
